export default __webpack_public_path__ + "static/media/featured-item-23.96781cc8.png";